package de.oevbs.kunde.kundenportal2.model.services.account

import de.oevbs.kunde.kundenportal2.validation.KupoValidationMessages
import dev.fritz2.core.Lenses
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.headless.validation.errorMessage
import dev.fritz2.validation.validation
import kotlinx.serialization.Serializable

@Lenses
@Serializable
data class DeleteAccount(
    val currentPassword: String = ""
) {
    companion object {
        val validation = validation<DeleteAccount, ComponentValidationMessage> { inspector ->
            val currentPass = inspector.map(DeleteAccount.currentPassword())
            if (currentPass.data.isEmpty()) {
                add(currentPass.errorMessage(KupoValidationMessages.EMPTY_INPUT))
            }
        }
    }
}